import buildUrl from '../utils/buildUrl';
import buildHeaders from '../utils/buildHeaders';
import buildBody from '../utils/buildBody';
const http = ({ url, method = 'GET', query, body, headers, user_credentials_params = 'include' }) => fetch(buildUrl(url, query), Object.assign(Object.assign({ method, headers: buildHeaders(headers) }, (body && { body: buildBody(body) })), { credentials: user_credentials_params }))
    .then((response) => {
    if (!response.ok)
        return Promise.reject(Object.assign(Object.assign({}, response), { success: false }));
    return response.text();
})
    .then((data) => {
    return data ? JSON.parse(data) : {};
})
    .then((response) => {
    if (response.error)
        return Promise.reject(Object.assign(Object.assign({}, response), { success: false }));
    return { success: true, data: response };
})
    .catch((e) => {
    return e;
});
export default http;
//# sourceMappingURL=index.js.map